import { Switch, Route, Redirect, useRouteMatch } from 'peach/router'

import WorkflowItemType from './WorkflowItemType'
import CreateWorkflowItemType from './CreateWorkflowItemType'
import WorkflowItemTypes from './WorkflowItemTypes'

const WorkflowItemTypesRoutes = () => {
  const { path, url } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={path}>
        <WorkflowItemTypes />
      </Route>

      <Route path={`${path}/create-workflow-item-type`}>
        <CreateWorkflowItemType />
      </Route>

      <Route path={`${path}/:workflowWorkitemTypeId`}>
        <WorkflowItemType />
      </Route>

      <Redirect to={url} />
    </Switch>
  )
}

export default WorkflowItemTypesRoutes
